import * as moment from "moment-timezone";
import { SeniorCenter, Timezone } from "./organization.model";
import { TimeData } from "./shared.model";

export interface GeneralResponse {
    message: string;
}

/* PROGRAM */
export interface Program {
    deliveryLogs: any;
    program_ref: string;
    name: string;
    event_info: string;
    active: boolean;
    recurring: boolean;
    senior_center_id: number;
    rec_frequency: number;
    event_start_timestamp: string;
    event_end_timestamp: string;
    send_alert_days_before?: number;
    cost: string;
    lang: string;
    type: string;
    interest_id: number;
    org_id?: number;
    reminder_alerts: AlertBeforeData[];
}

/**GET PROGRAM LIST */
export interface GetOrgProgramList {
    message: string;
    data: {
        count: number;
        rows: Program[];
    };
    page: number;
    limit: number;
}

/*Program Request */
export interface ProgramRequest {
    org_id: number;
    name: string;
    event_info: string;
    active: boolean;
    recurring: boolean;
    interest_id: number;
    senior_center_id: number | null;
    event_start_timestamp: string;
    event_end_timestamp: string;
    rec_frequency: number;
    send_alert_days_before?: number;
    reminder_alerts: AlertBeforeData[];
    cost: string;
    lang: string;
    type: string;
}

/*Program Form data */
export interface ProgramFormData {
    program_ref?: string;
    active: boolean;
    senior_center_id: number;
    senior_center?: SeniorCenter;
    name: string;
    event_info: string;
    lang: string;
    interest_id: number;
    type: string;
    cost: string;
    recurring: boolean;
    rec_frequency: number;
    event_start_date: moment.Moment;
    event_end_date: moment.Moment;
    event_start_time: TimeData;
    event_end_time: TimeData;
    send_alert_days_before?: number;
    reminder_alerts: AlertBeforeData[];
}

/* Program Responses */
export interface ProgramResponse {
    message: string;
    data: Program;
}

/* Reminders */
export interface Reminder {
    id: string;
    reminder_date: string;
    event_date: string;
    new_event_date: string;
    active: boolean;
};

/* Reminder List*/
export interface GetRemindersList {
    message: string;
    data: {
        count: number;
        rows: Reminder[];
    };
    page: number;
    limit: number;
}

/* Add Reminder */
export interface ReminderRequest {
    org_id: number;
    program_ref: string;
    reminder_date: string;
    active: boolean;
}

export interface AddReminderReq {
    org_id: number;
    program_ref: string;
    reminder_date: moment.Moment;
    event_end_date: moment.Moment;
    reminder_time: TimeData;
    active: boolean;
    minReminderDate?: moment.Moment;
    maxReminderDate?: moment.Moment;
}

export interface AddReminderDialogData { 
    reminderData: AddReminderReq, 
    timeZone: Timezone 
}

export interface AlertBeforeData {
  id?: number;
  program_reminder_id?: number;
  days_before: number;
  active?: boolean;
}

export interface AlertDayOption {
    daysBefore: number;
    label: string;
}